<template>
    <div>
        <div class="row" v-if="$gate.isReception() || $gate.isAdmin() || $gate.isSupervisor()">
            <div class="col-md-7">
                <Item :products="productItem" :target="'vmbc_product'" :Settings='POSType' :options="options" @modals="showModal" @Add-Product="Add"></Item>
            </div>
            <div class="col-md-5">

                <div class="row">
                    <!-- <multi-select :options="customers"
                        :selected-options="customer"
                        placeholder="Select Parent"
                        @change="test">
                    </multi-select> -->

                    <div class="col-md-12">
                        <sub class="text-danger">2nd (Customer, Location & Term is required)</sub>
<!--                        <basic-select :options="customers"-->
<!--                                    :selected-option="customer"-->
<!--                                    placeholder="Select Customer"-->
<!--                                    @select="onSelect">-->
<!--                        </basic-select>-->
                        <model-list-select :list="customerList"
                                           v-model="customer"
                                           option-value="value"
                                           option-text="text"
                                           placeholder="Select Customer"
                                           @searchchange="debouncedFetchCustomers"
                                           @select="onSelect">

                        </model-list-select>
                    </div>
                    <div class="col-md-12">
                         <model-list-select :list="locations"
                                            v-model="location"
                                            option-value="id"
                                            option-text="name"
                                            placeholder="Select Location"
                                            class="mt-2">
                        </model-list-select>
                    </div>

                    <div class="col-md-12">
                        <model-list-select :list="terms"
                                           v-model="term"
                                           option-value="drid"
                                           option-text="daterangename"
                                           placeholder="Select Term"
                                           class="mt-2">
                        </model-list-select>
                    </div>




                    <!-- <div class="col-md-12" v-if="customer.value !== ''">
                        <basic-select :options="customerStudentValue"
                                    :selected-option="student"
                                    placeholder="Select Student"
                                    @select="onSelect2">
                        </basic-select>
                    </div> -->

                    <Cart :tax_vat_one="tax_vat_one" :tax_vat="tax_vat" :carts="cartProduct" @add-qty="addQty" @sub-qty="subQty" @remove-cart="removecart" :students="customerStudentValue"/>

                    <Total
                    :tax_vat_one="tax_vat_one"
                    :tax_vat="tax_vat"
                    :carts="cartProduct"
                    :customer="customerDetails"
                    :student="customerStudent"
                    :settings="settings"
                    :location="location"
                    :location_required="true"
                    :term="term"
                    :term_required="true"
                    />
                </div>

            </div>
        </div>
        <div class="row" v-else>
            <notfound></notfound>
        </div>
    </div>
</template>

<script>
import Item from './Item.vue'
import Cart from './Cart.vue'
import Total from './Total.vue'
import { MultiSelect   } from 'vue-search-select'
import { BasicSelect } from 'vue-search-select'
import { ModelListSelect } from 'vue-search-select';


import Swal from 'sweetalert2'
import {debounce} from "lodash";
    window.Swal = Swal
    const toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
    });
export default {
    // props: ['user'],
    components: {
        BasicSelect,
        MultiSelect,
        Item,
        Cart,
        Total,
        ModelListSelect
    },
    data() {
        return {
            user: this.$root.id,
            POSType: {
                Category: "Product",
                IsProduct: 1,
                CartName: 'cartProduct',
                URL:  '/Sales-Product'
            },
            customers: [],
            customerList: [],
            customerDetails:[],
            customerStudent:[],
            customerStudentValue:[],
            productItem:[],
            options:[],
            settings: [],
            cartProduct: [],
            cartaddProduct: {
                id: '',
                product: '',
                option: '',
                price: '',
                quantity: '',
                notes: '',
                discount: '',
                priceExcl: '',
                total: '',
                excl: '',
                vat: '',
                xero: '',
                discountpercent:'',
                student: '',
            },
            customer: {
                value: '',
                text: ''
                },
            student: {
                value: '',
                text: ''
            },
            walkin: [],
            locations: [],
            location: {},
            terms: [],
            term: {}
        }
    },
    created() {
        this.getProducts();
        this.getSettings();
        //this.getCustomers();
        this.getLocations();
        this.viewCartProduct();
        this.users();
        this.getTerms();
        this.debouncedFetchCustomers = debounce(this.fetchCustomers, 600);
    },
    methods: {
        users() {
            let parsed = JSON.stringify(this.user);
            localStorage.setItem('user', parsed);

            let POSType = JSON.stringify(this.POSType);
            localStorage.setItem('POSType', POSType);
        },
        onSelect(items){
            //this.customer = items

            if(this.customer.value === 1){
                const {value: formValues} = Swal.fire({
                title: 'Multiple inputs',
                html:
                    '<input id="swal-input1" class="swal2-input" placeholder="name">' +
                    '<input id="swal-input2" class="swal2-input" placeholder="email">' +
                    '<input id="swal-input3" class="swal2-input" placeholder="mobile">',
                focusConfirm: false,
                preConfirm: () => {

                    this.walkin.name = document.getElementById('swal-input1').value,
                    this.walkin.email = document.getElementById('swal-input2').value,
                    this.walkin.mobile = document.getElementById('swal-input3').value

                }
                })
            }
                this.student= {}
                this.walkin = {}

                axios
                .get('./api/POS/Customers/'+ this.customer.value)
                .then((result) => {
                    this.customerDetails = result.data.mother
                    this.customerStudentValue = result.data.childvalue

                    let customer = JSON.stringify(this.customerDetails);
                    localStorage.setItem('customer', customer);

                    console.log(result)
                }).catch((err) => {
                    console.log(err)
                });
        },
        onSelect2(items){
            this.student = items

            axios
            .get('./api/POS/Student/' + this.student.value)
            .then((result) => {
                this.customerStudent = result.data.child

                let student = JSON.stringify(this.customerStudent);
                localStorage.setItem('student', student);
            }).catch((err) => {
                console.log(err)
            });

        },
        getCustomers() {
            axios
            .get('./api/POS/Customers')
            .then((result) => {
                this.customers = result.data;
            }).catch((err) => {
                console.log(err)
            });
        },
        fetchCustomers(searchQuery){
            if (searchQuery.length < 3) return;
            axios
                .get('./api/POS/Search/Customers/' + searchQuery)
                .then((result) => {
                    this.customerList = result.data
                }).catch((err) => {
                console.log(err)
            });

        },
        getLocations() {
            axios
            .get('./api/POS/Location')
            .then((result) => {
                this.locations = result.data
            }).catch((err) => {
                console.log(err)
            });
        },
        getTerms() {
            axios
                .get('./api/POS/Terms')
                .then((result) => {
                    this.terms = result.data
                }).catch((err) => {
                console.log(err)
            });
        },
        getProducts() {
            axios
            .get('./api/POS/Product')
            .then((result) => {
                this.productItem = result.data
            }).catch((err) => {
                console.log(err)
            });
        },
        showModal(e) {
            axios
            .get('./api/POS/Product/'+e)
            .then((result) => {
                this.options = result.data
            }).catch((err) => {
                console.log(err)
            });
        },
        Add(e){
            const id = this.cartProduct.find(product => product.id === e.option_id)

                if(!id) {
                    this.cartaddProduct.id = e.option_id
                    this.cartaddProduct.product = e.item_name
                    this.cartaddProduct.option = e.option_name
                    this.cartaddProduct.price = e.option_price
                    this.cartaddProduct.quantity = e.quantity
                    this.cartaddProduct.notes = e.notes
                    // this.cartaddProduct.discount = e.discount
                    // this.cartProduct.student = ''
                    this.cartaddProduct.xero = e.item_xero
                    this.cartaddProduct.priceExcl = parseFloat(e.option_price / this.tax_vat_one).toFixed(2)

                    let discount = 0
                    if(e.discountvalue == 'percent') {
                        discount = (e.quantity * e.option_price) * (e.discount / 100)
                    }
                    if(e.discountvalue == 'fixed') {
                        discount = e.discount
                    }

                    let discountpercent = 0
                    discountpercent = ((discount / (e.option_price * e.quantity)) * 100)

                    let total = 0
                    let excl = 0
                    let vat = 0

                    total = (e.quantity * e.option_price) - discount
                    excl = total / this.tax_vat_one
                    vat = excl * this.tax_vat

                    this.cartaddProduct.discount = parseFloat(discount).toFixed(2)
                    this.cartaddProduct.discountpercent = parseFloat(discountpercent).toFixed(2)
                    this.cartaddProduct.total = parseFloat(total).toFixed(2)
                    this.cartaddProduct.excl = parseFloat(excl).toFixed(2)
                    this.cartaddProduct.vat = parseFloat(vat).toFixed(2)


                    this.cartProduct.push(this.cartaddProduct)
                    // this.cartaddProduct = {}
                    this.storeCartProduct()

                    this.cartProduct.student = ''

                    e.notes = ''
                    e.discount = '0'
                    e.discountvalue = ''
                    e.quantity = '1'
                    $('.modal').modal('hide');
                    toast({
                        type: 'success',
                        title: 'Product add to cart'
                        })
                } else{
                    toast({
                    type: 'warning',
                    title: 'Product already in cart'
                    })
                }


        },
        removecart(index) {
            this.cartProduct.splice(index, 1)
            this.storeCartProduct()
        },
        storeCartProduct(){
            let parsed = JSON.stringify(this.cartProduct)
            localStorage.setItem(this.POSType.CartName, parsed)
            this.viewCartProduct();
        },
        viewCartProduct() {
            if(localStorage.getItem(this.POSType.CartName)){
                this.cartProduct = JSON.parse(localStorage.getItem(this.POSType.CartName))
            }
        },
        getSettings() {
            axios
            .get('./api/Settings')
            .then((result) => {
                this.settings = result.data
                let settings = JSON.stringify(result.data)
                localStorage.setItem('Settings', settings)
            }).catch((err) => {
                console.log(err)
            });
        },
        addQty(item) {
             Object.assign(item, {
                quantity: parseInt(item.quantity) + 1,
                excl: parseFloat(((item.quantity + 1) * item.price) - item.discount) / this.tax_vat_one,
                vat: parseFloat((((item.quantity + 1) * item.price) - item.discount) / this.tax_vat_one) * this.tax_vat,
                total: parseFloat((item.quantity + 1) * item.price) - item.discount
            })

            localStorage.setItem(this.POSType.CartName, JSON.stringify(this.cartProduct))
        },
        subQty(item) {
             Object.assign(item, {
                quantity: parseInt(item.quantity) - 1,
                excl: parseFloat(((item.quantity - 1) * item.price) - item.discount) / this.tax_vat_one,
                vat: parseFloat((((item.quantity - 1) * item.price) - item.discount) / this.tax_vat_one) * this.tax_vat,
                total: parseFloat((item.quantity - 1) * item.price) - item.discount
            })

            localStorage.setItem(this.POSType.CartName, JSON.stringify(this.cartProduct))
        },

    },
    watch:{
        customer(){
            this.onSelect();
        }
    },
    computed: {
        tax_vat() {
            return this.settings.reduce((total, tax) => {
                return total + (tax.Tax / 100)
            }, 0)
        },
        tax_vat_one() {
            return this.tax_vat + 1
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/POS/Product.vue